import { AddSpriteToFramesPayload } from "./frames.list.action";

export const ACTIVATE_ANIMATION: String = 'ACTIVATE_ANIMATION';
export const ADD_ANIMATION: String = 'ADD_ANIMATION';
export const SWIPE_ANIMATION: String = 'SWIPE_ANIMATION';
export const CHANGE_KEY_CONTROLS: String = 'CHANGE_KEY_CONTROLS';
export const EDIT_NAME_ANIMATION: String = 'EDIT_NAME_ANIMATION';
export const DELETE_ANIMATION: String = 'DELETE_ANIMATION';
export const RESET_ANIMATION: String = 'RESET_ANIMATION';
export const PLAY_STOP: String = 'PLAY_STOP';

// #### INTERFACES

// Add
export interface AddAnimationPayloadInterface {
    color: string;
    id: string;
    name: string;
    key_controls: KeyControlsInterface;
    play: boolean;
    frames: Array<AddSpriteToFramesPayload>
}
// Swipe animations
export interface SwipeAnimations {
    type: typeof SWIPE_ANIMATION,
    payload: Array<AddAnimationPayloadInterface>
}

export interface KeyControlsInterface {
    repeat: number;
    frame_rate: number;
    yoyo?: boolean;
}
// Update key_controls
export interface ChangeKeyControlsPayload {
    id: string;
    key_controls: KeyControlsInterface
}
export interface ChangeKeyControls {
    type: typeof CHANGE_KEY_CONTROLS,
    payload: ChangeKeyControlsPayload
}

// Activate animation
export interface ActivateAnimationPayloadInterface {
    id: string;
}
export interface ActivateAnimationActionInterface {
    type: typeof ACTIVATE_ANIMATION;
    payload: ActivateAnimationPayloadInterface
}


export interface AddAnimationActionInterface {
    type: typeof ADD_ANIMATION;
    payload: AddAnimationPayloadInterface;
}

// Edit
export interface EditNameAnimationPayloadInterface {
    id: string;
    name: string
}
export interface EditAnimationActionInterface {
    type: typeof EDIT_NAME_ANIMATION;
    payload: EditNameAnimationPayloadInterface
}

// Delete
export interface DeleteAnimationPayloadInterface {
    id: string;
}
export interface DeleteAnimationActionInterface {
    type: typeof EDIT_NAME_ANIMATION;
    payload: DeleteAnimationPayloadInterface
}

// Play stop
export interface PayloadStop {
    id: string, 
    play: boolean
}


export type AnimationActionTypes = ChangeKeyControls & DeleteAnimationActionInterface & AddAnimationActionInterface & EditAnimationActionInterface & ActivateAnimationActionInterface & SwipeAnimations;

// #### ACTIONS
export const ChangeKeyControlsAction = (payload: ChangeKeyControlsPayload): ChangeKeyControls => {
    return {
        type: CHANGE_KEY_CONTROLS,
        payload
    }
}

export const ActivateAnimation = (payload: ActivateAnimationPayloadInterface): ActivateAnimationActionInterface => {
    return {
        type: ACTIVATE_ANIMATION,
        payload
    }
}

export const AddAnimationAction = (payload: AddAnimationPayloadInterface): AddAnimationActionInterface => {
    return {
        type: ADD_ANIMATION,
        payload
    }
}

export const SwipeAnimationsAction = (payload: Array<AddAnimationPayloadInterface>): SwipeAnimations => {
    return {
        type: SWIPE_ANIMATION,
        payload
    }
}

export const EditNameAnimationAction = (payload: EditNameAnimationPayloadInterface): EditAnimationActionInterface => {
    return {
        type: EDIT_NAME_ANIMATION,
        payload
    }
}

export const DeleteAnimationAction = (payload: DeleteAnimationPayloadInterface): DeleteAnimationActionInterface => {
    return {
        type: DELETE_ANIMATION,
        payload
    }
}

export const ResetAnimation = () => {
    return {
        type: RESET_ANIMATION
    }
}

export const PlayStopAction = (payload: PayloadStop) => {
    return {
        type: PLAY_STOP,
        payload
    }
}